module.exports = __webpack_public_path__ + "static/media/videocall.95c56717.png";